(() => {
  const dismissKey = 'dura-cart-offer-dismissed';
  const applyDismissed = () => {
    if (sessionStorage.getItem(dismissKey) === '1') {
      document.querySelectorAll('[data-dura-cart-offer]').forEach((offer) => offer.hidden = true);
    }
  };
  document.addEventListener('click', async (event) => {
    const close = event.target.closest('[data-dura-offer-close]');
    if (close) {
      sessionStorage.setItem(dismissKey, '1');
      close.closest('[data-dura-cart-offer]').hidden = true;
      return;
    }
    const button = event.target.closest('[data-dura-add-variant]');
    if (!button) return;
    const offer = button.closest('[data-dura-cart-offer]');
    const status = offer.querySelector('[data-dura-offer-status]');
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((section) => section.id) : ['cart-drawer','cart-icon-bubble'];
      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:Number(button.dataset.duraAddVariant),quantity:1}],sections,sections_url:window.location.pathname})
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || 'Ekki tókst að bæta við.');
      if (drawer && drawer.renderContents && state.sections) {
        drawer.renderContents({...state,id:Number(button.dataset.duraAddVariant)});
        requestAnimationFrame(applyDismissed);
      } else {
        location.reload();
      }
    } catch (error) {
      status.textContent = error.message;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('DOMContentLoaded', applyDismissed);
  applyDismissed();
})();